module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-accordion",
    class: {
      'm-accordion__body-map': _vm.bodyMap
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ad32f122!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/accordion/Accordion.vue
// module id = 1790
// module chunks = 0